import useSessionActivity from "./session/useSessionActivity";
import useSessionHeartbeat from "./session/useSessionHeartbeat";
import useSessionIdentity from "./session/useSessionIdentity";
import useSessionLoader from "./session/useSessionLoader";

export default function useSessionTimeout(onSessionEnded) {
  const session = useSessionIdentity(onSessionEnded);
  const { heartbeat, lastHeartbeatRef } = useSessionHeartbeat(session);
  const { lastActivityRef, recordActivity } = useSessionActivity({
    ...session,
    heartbeat,
    lastHeartbeatRef,
  });
  useSessionLoader({ lastActivityRef, setActiveUser: session.setActiveUser });

  return {
    endSession: session.endSession,
    recordActivity,
    showWarning: session.showWarning,
    user: session.user,
  };
}